import type { RouteObject } from 'react-router-dom';

import { ModerationErrorBoundary } from './components/ModerationErrorBoundary';
import { ModerationGuard } from './components/ModerationGuard';
import { CommunityModerationDashboardPage, ModerationTopicDetailPage, ModerationWorkQueuePage } from './pages';

/**
 * Get community-scoped moderation route configuration
 * These routes will be integrated into the communities routing
 *
 * Uses ModerationGuard for authorization:
 * - Moderator role in the specific community (from community.roles)
 * - Admin role in the specific community (from community.roles)
 *
 * Wrapped with ModerationErrorBoundary for comprehensive error handling
 *
 * Route structure for breadcrumbs:
 * - moderation (Moderation)
 *   - index → Dashboard
 *   - :topicId (Topic Name)
 *     - index → Topic Detail
 *     - queue (Work Queue)
 */
export function getCommunityModerationRouteConfig(): RouteObject[] {
  return [
    {
      path: 'moderation',
      handle: { breadcrumb: 'Moderation' },
      children: [
        {
          index: true,
          element: (
            <ModerationErrorBoundary>
              <ModerationGuard>
                <CommunityModerationDashboardPage />
              </ModerationGuard>
            </ModerationErrorBoundary>
          ),
        },
        {
          path: ':topicId',
          children: [
            {
              index: true,
              element: (
                <ModerationErrorBoundary>
                  <ModerationGuard>
                    <ModerationTopicDetailPage />
                  </ModerationGuard>
                </ModerationErrorBoundary>
              ),
            },
            {
              path: 'queue',
              element: (
                <ModerationErrorBoundary>
                  <ModerationGuard>
                    <ModerationWorkQueuePage />
                  </ModerationGuard>
                </ModerationErrorBoundary>
              ),
              handle: { breadcrumb: 'Work Queue' },
            },
          ],
        },
      ],
    },
  ];
}
